__turbopack_context__.v({
  "sidebar": "_8LeoG_sidebar",
  "sidebar__page": "_8LeoG_sidebar__page",
  "sidebar__page--active": "_8LeoG_sidebar__page--active",
  "sidebar__section-pages": "_8LeoG_sidebar__section-pages",
  "sidebar__section-title": "_8LeoG_sidebar__section-title",
  "sidebar__sections": "_8LeoG_sidebar__sections",
  "sidebar__sections--collapsed": "_8LeoG_sidebar__sections--collapsed",
  "sidebar__tag": "_8LeoG_sidebar__tag",
  "sidebar__title": "_8LeoG_sidebar__title",
  "sidebar__toggle": "_8LeoG_sidebar__toggle",
});
